define('extensions/knockoutExtenders/byteConverter',[
    'lib/knockout',
    'extensions/i18n/knockout.i18n'
],function (ko) {
    "use strict";

    //Extends an observable (or computed observable) so that bytes are converted to MB on write
    //and MB get converted to bytes on read
    ko.extenders.byteConverter = function(target,options) {
        var shouldRound = options && options.round !== null ? options.round: true; //rounding is default
        target.byte = ko.observable();
        target.megaByte = ko.observable();

        function convertToMB(value){
            if (typeof value !=='undefined' && value !==null){
                var sizeMB = value / Math.pow(1024, 2);
                sizeMB =  ko.i18n.format(sizeMB.toFixed(2),"n");
                if(shouldRound){
                    sizeMB = Math.round(sizeMB);
                }
                target.byte(value);
                target.megaByte(sizeMB);
            }
        }
        convertToMB(target());
        target.subscribe(convertToMB);

        return target;
    };
});
